import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MediaLoadingType } from '../models/models';
import { SocialComponent } from '../social/social.component';
import { RxIf } from '@rx-angular/template/if';
import { fadeIn } from '../animations/fade-in.animation';


@Component({
  selector: 'lib-media',
  standalone: true,
  imports: [CommonModule, SocialComponent, RxIf],
  templateUrl: './media.component.html',
  styleUrl: './media.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeIn]
})
export class MediaComponent {
  // @Input({ required: true}) media!: Media;
  


  @Input({ required: true }) src!: string;
  @Input() srcset?: string;
  @Input() sizes?: string;
  @Input() type: 'image' | 'video' = 'image';
  @Input() alt = '';
  @Input() loading?: MediaLoadingType = 'eager';

  readonly loaded = signal(false);

  onLoad() {
    this.loaded.set(true);
  }

  onError(error: any) {
    this.loaded.set(true);
    console.log('MediaComponent - load media ERROR, type: ', this.type, error);
  }

  getMp = (src: string):string => src.replace('.webm', '.mp4');

}


